import React, { Component } from "react";
import { Text } from "react-internationalization";
import { connect } from "react-redux";
class PreviewPageStep1 extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { data } = this.props;
    return (
      <div>
        <label class="control-label mt-3">
          <strong>
            <Text id="app.PERSONALINFO" />
            &nbsp;
            <a onClick={this.props.changeToSection1} class="cursor-pointer">
              <i class="fas fa-edit"></i>
            </a>
          </strong>
        </label>
        <div class="row">
          <div class="col">
            {data?.prefix ? (
              <p>
                <Text id="app.Prefix" />
                :&nbsp;
                <strong>{data?.prefix}</strong>
              </p>
            ) : null}
            {data?.firstName ? (
              <p>
                <Text id="app.FirstName" />
                :&nbsp;
                <strong>{data?.firstName}</strong>
              </p>
            ) : null}

            {data?.birthDate ? (
              <p>
                <Text id="app.BirthDate" />
                :&nbsp;
                <strong>{data.birthDate}</strong>
              </p>
            ) : null}
            {data?.primaryPhoneNum ? (
              <p>
                <Text id="app.PrimaryPhoneNumber" />
                :&nbsp;
                <strong>{data.primaryPhoneNum}</strong>
              </p>
            ) : null}
            {data?.cellPhoneNum ? (
              <p>
                <Text id="app.CellPhoneNumber" />
                :&nbsp;
                <strong>{data.cellPhoneNum}</strong>
              </p>
            ) : null}
            {data?.permanentAddr2 || data?.permanentAddress?.permanentAddr2 ? (
              <p>
                <Text id="app.permanentaddress2" />
                :&nbsp;
                <strong>
                  {data?.permanentAddress?.permanentAddr2 ||
                    data?.permanentAddr2}
                </strong>
              </p>
            ) : null}
            {data?.permanentCity || data?.permanentAddress?.city ? (
              <p>
                <Text id="app.City" />
                *:&nbsp;
                <strong>
                  {data?.permanentAddress?.city || data?.permanentCity}
                </strong>
              </p>
            ) : null}
            {/* {data?.state || data?.permanentAddress?.state ? ( */}
            <p>
              <Text id="app.State" />
              *:&nbsp;
              <strong>
                {/* {data?.permanentAddress?.state
                    ? data?.permanentAddress?.state
                    : data?.state} */}
                {this?.props?.mbiDetails?.status === "MATCHED"
                  ? this.props.stateId
                  : this.props.preEnrollInfo.appNumber
                  ? this.props.deeplink
                    ? this.props.stateId
                    : this.props.preEnrollInfo.permanentAddress.state
                  : this.props.stateId}
              </strong>
            </p>
            {/* ) : null} */}
            {data?.permanentZip4 || data?.permanentAddress?.permanentZip4 ? (
              <p>
                <Text id="app.permanentZip4" />
                :&nbsp;
                <strong>
                  {data?.permanentAddress?.permanentZip4 || data?.permanentZip4}
                </strong>
              </p>
            ) : null}
            
            {data?.mailingAddr || data?.mailingAddress?.streetAddress ? (
              <p>
                <Text id="step4Agent.malAdd" />
                *:&nbsp;
                <strong>{data?.mailingAddr ? data?.mailingAddr : ""}</strong>
              </p>
            ) : null}

{data?.mailingAddr2 || data?.mailingAddress?.mailingAddr2 ? (
              <p>
                <Text id="app.mailingaddress2" />
                :&nbsp;
                <strong>{data?.mailingAddr2 ? data?.mailingAddr2 : ""}</strong>
              </p>
            ) : null}
            {data?.mailingState || data?.mailingAddress?.state ? (
              <p>
                <Text id="step4Agent.mailingState" />
                *:&nbsp;
                <strong>{data?.mailingState ? data?.mailingState : ""}</strong>
              </p>
            ) : null}
            {data?.mailingZip4 || data?.mailingAddress?.mailingZip4 ? (
              <p>
                <Text id="app.mailingZip4" />
                :&nbsp;
                <strong>{data?.mailingZip4 ? data?.mailingZip4 : ""}</strong>
              </p>
            ) : null}

            {data?.medicareNumber ? (
              <p>
                <Text id="app.MedicareNo" />
                *:&nbsp;
                <strong>{data?.medicareNumber}</strong>
              </p>
            ) : null}
            {data?.partAEffDate ? (
              <p>
                <Text id="step4Agent.effDateA" />
                *:&nbsp;
                <strong>{data?.partAEffDate}</strong>
              </p>
            ) : null}
            {data?.covMemberNumber ? (
              <p>
                <Text id="app.mebernumber" />
                *:&nbsp;
                <strong>{data?.covMemberNumber}</strong>
              </p>
            ) : null}
            {data?.nameOfRep ? (
              <p>
                <Text id="step4Agent.authrepfname" />
                *:&nbsp;
                <strong>{data?.nameOfRep}</strong>
              </p>
            ) : null}
            {data?.middleNameOfRep ? (
              <p>
                <Text id="step4Agent.authrepmname" />
                :&nbsp;
                <strong>{data?.middleNameOfRep}</strong>
              </p>
            ) : null}
            {data?.addressOfRep2 || data?.authRepAddress?.address2 ? (
              <p>
                <Text id="step4Agent.authrepAdr2" />
                :&nbsp;
                <strong>
                  {data?.authRepAddress?.address2
                    ? data?.authRepAddress?.address2
                    : data?.addressOfRep2}
                </strong>
              </p>
            ) : null}
            {data?.authRepCity || data?.authRepAddress?.city ? (
              <p>
                <Text id="step4Agent.authrepCity" />
                *:&nbsp;
                <strong>
                  {data?.authRepAddress?.city
                    ? data?.authRepAddress?.city
                    : data?.authRepCity}
                </strong>
              </p>
            ) : null}
            {data?.authRepZip || data?.authRepAddress?.zipCode ? (
              <p>
                <Text id="step4Agent.authrepZip" />
                *:&nbsp;
                <strong>
                  {data?.authRepAddress?.zipCode
                    ? data?.authRepAddress?.zipCode
                    : data?.authRepZip}
                </strong>
              </p>
            ) : null}
            {data?.relationOfRep ? (
              <p>
                <Text id="step4Agent.authreprelation" />
                *:&nbsp;
                <strong>
                  {/* {data?.relationOfRep} */}
                  {
                    this.props.authorizedrelations.filter(
                      (data1) => data1.value == data?.relationOfRep
                    )[0]?.label
                  }
                </strong>
              </p>
            ) : null}
          </div>
          <div class="col">
            {data?.lastName ? (
              <p>
                <Text id="app.LastName" />
                :&nbsp;
                <strong>{data.lastName}</strong>
              </p>
            ) : null}
            {data?.middleInitial ? (
              <p>
                <Text id="app.MI" />
                :&nbsp;
                <strong>{data?.middleInitial}</strong>
              </p>
            ) : null}
            {data?.sex ? (
              <p>
                <Text id="app.Sex" />
                :&nbsp;
                <strong>
                  {data?.sex
                    ? data?.sex === "M"
                      ? "Male"
                      : data?.sex === "F"
                      ? "Female"
                      : data?.sex === "U"
                      ? "Unknown"
                      : ""
                    : ""}
                </strong>
              </p>
            ) : null}
            {data?.proposedEffDate ? (
              <p>
                <Text id="app.propEffDate" />
                *:&nbsp;
                <strong>{data?.proposedEffDate}</strong>
              </p>
            ) : null}
            {data?.permanentAddrStreet ||
            data?.permanentAddress?.streetAddress ? (
              <p>
                <Text id="app.PermanentAddress" />
                *:&nbsp;
                <strong>
                  {
                  /* {data?.permanentAddress?.streetAddress.trim().length > 0
                    ? data?.permanentAddress?.streetAddress */
                      data?.permanentAddrStreet?? ""
                      }
                </strong>
              </p>
            ) : null}
            {data?.permanentCounty ? (
              <p>
                <Text id="app.County" />
                *:&nbsp;
                <strong>{data?.permanentCounty}</strong>
              </p>
            ) : null}
            {data?.permanentZip || data?.permanentAddress?.zipCode ? (
              <p>
                <Text id="app.ZIPCode" />
                *:&nbsp;
                <strong>
                  {data?.permanentAddress?.zipCode
                    ? data?.permanentAddress?.zipCode
                    : data?.permanentZip}
                </strong>
              </p>
            ) : null}
            {data?.mailingCity || data?.mailingAddress?.city ? (
              <p>
                <Text id="step4Agent.mailingCity" />
                *:&nbsp;
                <strong>{data?.mailingCity ? data?.mailingCity : ""}</strong>
              </p>
            ) : null}
            {data?.mailingCounty || data?.mailingAddress?.county ? (
              <p>
                <Text id="step4Agent.mailingCounty" />
                *:&nbsp;
                <strong>
                  {data?.mailingCounty ? data?.mailingCounty : ""}
                </strong>
              </p>
            ) : null}
            {data?.mailingzip || data?.mailingAddress?.zipCode ? (
              <p>
                <Text id="step4Agent.mailingZip" />
                *:&nbsp;
                <strong>{data?.mailingzip ? data?.mailingzip : ""}</strong>
              </p>
            ) : null}
            {data?.partBEffDate ? (
              <p>
                <Text id="step4Agent.effDateB" />
                *:&nbsp;
                <strong>{data?.partBEffDate}</strong>
              </p>
            ) : null}
            {data?.nameOfCoverage ? (
              <p>
                <Text id="app.coverage" />
                *:&nbsp;
                <strong>{data?.nameOfCoverage}</strong>
              </p>
            ) : null}
            {data?.covGroupNumber ? (
              <p>
                <Text id="app.groupNo" />
                *:&nbsp;
                <strong>{data?.covGroupNumber}</strong>
              </p>
            ) : null}
            {data?.lastNameOfRep ? (
              <p>
                <Text id="step4Agent.authreplname" />
                *:&nbsp;
                <strong>{data?.lastNameOfRep}</strong>
              </p>
            ) : null}
            {data?.addressOfRep || data?.authRepAddress?.streetAddress ? (
              <p>
                <Text id="step4Agent.authrepAdr1" />
                *:&nbsp;
                <strong>
                  {data?.authRepAddress?.streetAddress
                    ? data?.authRepAddress?.streetAddress
                    : data?.addressOfRep}
                </strong>
              </p>
            ) : null}
            {data?.address3 || data?.authRepAddress?.address3 ? (
              <p>
                <Text id="step4Agent.authrepAdr3" />
                :&nbsp;
                <strong>
                  {data?.authRepAddress?.address3
                    ? data?.authRepAddress?.address3
                    : data?.address3}
                </strong>
              </p>
            ) : null}
            {data?.authRepState || data?.authRepAddress?.state ? (
              <p>
                <Text id="step4Agent.authrepState" />
                *:&nbsp;
                <strong>
                  {data?.authRepAddress?.state
                    ? data?.authRepAddress?.state
                    : data?.authRepState}
                </strong>
              </p>
            ) : null}
            {data?.authZip4 || data?.authRepAddress?.authZip4 ? (
              <p>
                <Text id="app.authrepZip4" />
                :&nbsp;
                <strong>
                  {data?.authRepAddress?.authZip4 || data?.authZip4}
                </strong>
              </p>
            ) : null}
            {data?.phoneNumberOfRep ? (
              <p>
                <Text id="step4Agent.authrepphne" />
                *:&nbsp;
                <strong>{data?.phoneNumberOfRep}</strong>
              </p>
            ) : null}
          </div>
        </div>
        <div class="form-group row mt-3">
          <div class="col-md-6">
            <label for="SRName" class="control-label">
              <Text id="step4Agent.SRName" />
            </label>
            <input
              type="text"
              id="SRName"
              name="SRName"
              disabled="true"
              value={this.props?.agentName?.split("-")[1]}
              class={"form-control cursor-notallowed"}
              autoComplete="off"
              spellcheck="false"
              aria-autocomplete="both"
              aria-haspopup="false"
            />
          </div>
          <div class="col-md-6">
            <label for="SRLicNo" class="control-label">
              <Text id="step4Agent.SRLicNo" />
            </label>
            <input
              type="text"
              id="SRLicNo"
              name="SRLicNo"
              disabled="true"
              value={this.props?.agentName?.split("-")[0]}
              class={"form-control  cursor-notallowed"}
              autoComplete="off"
              spellcheck="false"
              aria-autocomplete="both"
              aria-haspopup="false"
            />
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    agentId: state.login.agentId,
    agentName: state.webApp.soa?.agentName,
    mbiDetails: state.login.mbiDetails,
    stateId: state.webApp.stateId,
    preEnrollInfo: state.webApp.preEnrollInfo,
    deeplink: state.login.deeplink,
  };
};
export default connect(mapStateToProps)(PreviewPageStep1);
